import { Route } from "react-router-dom";
import DownloadsScreen from "./DownloadsScreen";

export const routes = (
  <Route index path="downloads" Component={DownloadsScreen} />
);
